import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap'
import '../styles/Hero.css';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';
import LodgifySearchBox from './lodgifySearchBox';

const locales = ['en', 'fr'];
const texts = {
    WELCOME: {
        en: "Welcome to",
        fr: "Bienvenue à",
        ru: "Добро пожаловать",
    },
    GET_STARTED: {
        en: "Get Started",
        fr: "Commencer",
        ru: "Начать",
    }
}

const setSection =(section, props, inView)=>{
    if(inView && props.nav !== section){
      props.setNav(section);
    }
  }

const Hero =(props)=> {
    const section = 'home';
    const lang = props.lang;
    const { ref, inView } = useInView({threshold: 0.8});
    useEffect(() => {
      setSection(section, props, inView);
    });
    return (
            <section id="home" ref={ref}>
                <div className="home-container">
                    <h2>{texts.WELCOME[lang]}</h2>
                    <h1>La Croix De Millorit</h1>
                    <h3><strong>Château</strong></h3>
                    
                    <ButtonGroup aria-label="Basic example" className="langBtnGroup" >
                        {
                            locales.map((loc, i)=> {
                                return(
                                    <Button key={i} 
                                            className={`langBtn ${loc === lang ? "selected" : ""}`}
                                            onClick={()=>{props.setLang(loc)}}
                                            >
                                        <img src={`/flag-${loc}.png`} alt="" width="32px" className="img-fluid"/>
                                    </Button>
                                )
                            })
                        }
                    </ButtonGroup>

                    {/* <LodgifySearchBox lang={props.lang}/> */}
                    <a href="#chateau" className="btn btn-get-started scrollto">{texts.GET_STARTED[lang].toUpperCase()}</a>

                </div>
            </section>
    )
}

export default Hero;